<template>
  <div class="contenido">
    <Loading :active="isLoading" :can-cancel="true" :is-full-page="fullPage" />

    <Titulo titulo="PROCESAR PAGO" />

    <b-container class="mt-5">
        <h4 class="text-center well text-muted text-uppercase"
            v-if="paypal.clientId != '' && mercadoPago.key != ''"
        >
            Elige la forma de pago
        </h4>
        <!-- paypal -->
        <b-row align-h="between" v-if="paypal.clientId != ''">
            <b-col cols="12" sm="4" >
                <img src="../assets/paypal.jpg" width="150px" class="img-thumbnail">
            </b-col>
            <b-col cols="12" sm="4" class="text-right">
                <div id="botonPaypal"></div>
            </b-col>
        </b-row>
        <!-- separador de forma de pago -->
        <b-row v-if="paypal.clientId != ''">
            <b-col cols="12">
                <hr class="separadorCheckout">
            </b-col>
        </b-row>
        <!-- mercado pago -->
        <b-row align-h="between" v-if="mercadoPago.key != ''">
            <b-col cols="12" sm="4">
                <img src="../assets/mercadoPago.jpg" width="150px" class="img-thumbnail">
            </b-col>
            <b-col cols="12" sm="4" class="text-right">
                <button type="button" 
                    class="btn btn-default btn-mercadoPago"
                >
                </button>
            </b-col>
        </b-row>
        <!-- separador de forma de pago -->
        <b-row v-if="mercadoPago.key != ''">
            <b-col cols="12">
                <hr class="separadorCheckout">
            </b-col>
        </b-row>

        <h4 class="text-center well text-muted text-uppercase">Detalle de su pago</h4>
        
        <!-- los totales a pagar -->
        <b-row class="text-right">
            <b-col cols="12" offset-sm="8" sm="2" md="2">
                <span><strong>Cuotas</strong></span>
            </b-col>
            <b-col cols="12" sm="2" md="2">
                <span>{{ totalCuotas | moneda }}</span>
            </b-col>
        </b-row>
        <b-row class="text-right">
            <b-col cols="12" offset-sm="8" sm="2" md="2">
                <span><strong>Recargos</strong></span>
            </b-col>
            <b-col cols="12" sm="2" md="2">
                <span>{{ totalRecargos | moneda }}</span>
            </b-col>
        </b-row>
        <b-row class="text-right">
            <b-col cols="12" offset-sm="8" sm="2" md="2">
                <span><strong>Gastos</strong></span>
            </b-col>
            <b-col cols="12" sm="2" md="2">
                <span>{{ totalGastos | moneda }}</span>
            </b-col>
        </b-row>
        <b-row class="text-right">
            <b-col cols="12" offset-sm="8" sm="2" md="2">
                <span><strong>Otros cargos</strong></span>
            </b-col>
            <b-col cols="12" sm="2" md="2">
                <span>{{ otrosCargos | moneda }}</span>
            </b-col>
        </b-row>
        <b-row class="text-right">
            <b-col cols="12" offset-sm="8" sm="2" md="2">
                <span><strong>Total</strong></span>
            </b-col>
            <b-col cols="12" sm="2" md="2">
                <span><strong>{{ granTotal | moneda }}</strong></span>
            </b-col>
        </b-row>


        <!-- el boton de regresar -->
        <b-row class="d-flex justify-content-end mt-3 mb-3 mr-0">
            <b-button
                variant="primary"
                @click="regresar"
            >
                <b-icon-chevron-left></b-icon-chevron-left> Regresar
            </b-button>
        </b-row>
    </b-container>
  </div>

</template>

<script>
import Titulo from "@/components/Titulo.vue";
import Swal from "sweetalert2";
const axios = require("axios");
import { mapState } from "vuex";
var numeral = require("numeral");
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { loadScript } from "@paypal/paypal-js";

export default {
  name: "Pagos",
  filters: {
    numero: function (value) {
      return numeral(value).format("0,0.00");
    },
    moneda: function (value) {
      return numeral(value).format("$0,0.00");
    },
  },
  components: {
    Titulo,
    Loading,
  },
  data() {
    return {
      //
      contrato: {},
      parametros: {},
      detalle_saldos: [],
      selected: [],
      fields: [
        "periodo",
        "concepto",
        { key: "tipo_cuota", label: "Tipo de cuota" },
        "cuotas",
        "recargos",
        "total",
      ],
      // el spinner de carga
      isLoading: true,
      fullPage: true,
      // para los pagos de paypal
      loaded: false,
      paidFor: false,
      product: {
          price: 777.77,
          description: "Pago de cuotas de mantenimiento",
      }
    };
  },
  created() {
    this.parametros = JSON.parse(localStorage.getItem("parametros"))
    this.contrato = JSON.parse(localStorage.getItem("contrato"))
    this.detalle_saldos = JSON.parse(localStorage.getItem("detalle_saldos"))
  },
  mounted() {
    if (this.paypal.clientId != '') {
        this.cargarPaypal()
    }

    if (this.mercadoPago.key != '') {
        this.cargarMercadoPago()
    }

    if (this.paypal.clientId == '' && this.mercadoPago.key == '') {
        this.isLoading = false;
    }
  },
  methods: {
        cargarPaypal(){
          this.product.price = this.granTotal

          loadScript({ "client-id": "AVuc0nfQpSrgxEieJZXj3-oletFR-hwVqrosT6FBgaVVhN3PagfdTbutZFD21VbpDjA8p6MrI2FLFe8A", currency: "MXN" })
            .then((paypal) => {
                paypal
                    .Buttons({
                        createOrder: (data, actions) => {
                            return actions.order.create({
                                purchase_units: [
                                    {
                                        amount: {
                                            value: this.product.price,
                                            currency: "MXN",
                                            breakdown: {
                                                item_total: {
                                                    currency_code: "MXN",
                                                    value: this.product.price,
                                                },
                                            },
                                        },
                                        description: this.product.description,
                                    },
                                ],
                            });
                        },
                        onApprove: async (data, actions) => {
                            const order = await actions.order.capture();
                            this.paidFor = true;
                            this.aplicarPaypal(order)
                        },
                    })
                    .render("#botonPaypal")
                    .catch((error) => {
                        console.error("failed to render the PayPal Buttons", error);
                    });
            })
            .catch((error) => {
                console.error("failed to load the PayPal JS SDK script", error);
            });

            this.isLoading = false;
        },
        cargarMercadoPago() {
            const script = document.createElement("script");
            
            script.src = "https://sdk.mercadopago.com/js/v2";
            script.addEventListener("load", this.cargadoMeradoPago)

            document.body.appendChild(script);
        },
        async cargadoMeradoPago() {
            if (this.mercadoPago.modo_prueba == 'S') {
                var pulicKey = this.mercadoPago.testKey
            } else {
                var pulicKey = this.mercadoPago.key
            }

            const mp = new MercadoPago(pulicKey, {
                locale: "es-MX",
            });

            // Inicializa el checkout
            var formData = new FormData();
            formData.append("accion", "inicializar")
            formData.append("idUsuario", this.idUsuario)
            formData.append("idContrato", this.contrato.ID_CONTRATO)
            formData.append("importe", this.granTotal)

            const res = await fetch(`${this.url}/ajax/ajax.mercadoPago.php`,{method: 'POST', body: formData})
            var resp = await res.json()

            mp.checkout({
                preference: {
                    id: resp.id,
                },
                render: {
                    container: ".btn-mercadoPago",
                    label: "Pagar",
                },
            });

            this.isLoading = false;
        },
        aplicarPaypal(order){
            var formData = new FormData();
            formData.append("accion", "procesarPago");
            formData.append("idContrato", this.contrato.ID_CONTRATO);
            formData.append("cuotas", this.totalCuotas)
            formData.append("recargos", this.totalRecargos)
            formData.append("gastos", this.totalGastos)
            formData.append("otrosCargos", this.otrosCargos)
            formData.append("total", this.granTotal)
            formData.append("detalles", JSON.stringify(this.detalle_saldos))
            
            axios.post(`${this.url}/ajax/ajax.paypal.php`, formData)
            .then(res => {
                if (res.data.estado == "ok") {
                    this.$router.push("/finalizapago");
                } else {
                    Swal.fire({
                        title: "Error",
                        text: res.data.mensaje,
                        icon: "error",
                        confirmButtonText: "Aceptar",
                        confirmButtonColor: "#3085d6",
                    });
                }
            });
        },
        aplicarMercadoPago() {
            alert('pendiente')
        },
        regresar() {
            this.$router.push("/consultasaldo");
        },
  },
  computed: {
    url() {
      if (["localhost", "127.0.0.1", ""].includes(window.location.hostname)) {
        return this.urlSandbox;
      } else {
        return this.urlProd;
      }
    },
    ...mapState(["urlProd", "urlSandbox", 'idUsuario', 'tipoUsuario', 'usuario', 'paypal', 'mercadoPago']),
    totalCuotas() {
        var total = 0;

        this.detalle_saldos.forEach((element) => {
            if (element.periodo != "") {
            total += Number(element.cuotas);
            }
        });

        return total.toFixed(2);
    },
    totalRecargos() {
        var total = 0;
        this.detalle_saldos.forEach((element) => {
            total += Number(element.recargos);
        });
        return total.toFixed(2);
    },
    totalGastos() {
        return 0.0;
    },
    otrosCargos() {
        var total = 0;
        this.detalle_saldos.forEach((element) => {
            if (element.periodo == "") {
            total += Number(element.cuotas);
            }
        });
        return total.toFixed(2);
    },
    granTotal() {
        var cuotas = 0;
        var recargos = 0;
        var otros_cargos = 0;
        var total = 0;

        this.detalle_saldos.forEach((element) => {
          if (element.periodo == "") {
            cuotas += Number(element.cuotas);
          } else {
            otros_cargos += Number(element.cuotas);
          }
          recargos += Number(element.recargos);
        });

        total = cuotas + recargos + otros_cargos;
        return total.toFixed(2);
    },
  },
};
</script>

<style scoped>
    .contenido {
        min-height: 500px;
    }

    .gridDatos {
        overflow-y: scroll;
        height: 350px;
    }

    .modalTitulo{
        padding:5px 0px;
    }

    .modalTitulo h3{
        text-align:center;
        margin-top:-5px;
        padding:15px 0px;
        border-radius:5px 5px 0px 0px;
    }

    .modalFormulario .close{
        position:absolute;
        right:27px;
        top:15px;
        color:white;
    }

    .modalFormulario .modalFormulario{
        cursor:pointer;
    }

    .modalFormulario p i{
        margin-left:-25px;
        margin-right:25px;
        font-size:25px;	
    }

    .modalFormulario form{
        padding:20px;
    }

    .modalFormulario form hr{
        border:1px solid #eee;
    }

    .modalFormulario form input[type="text"], .modalFormulario form input[type="email"], .modalFormulario form input[type="password"]{
        padding:25px;
    }
    .modalFormulario form input[type="submit"]{
        padding:15px;
    }

    .modalFormulario form .checkBox{
        margin-top:10px;
    }

    .modalTitulo .importePagar {
        padding: 0px 40px;
        font-size: 24px;
    }

    /* para los formularios */
    .backColor, .backColor a{
        background:#007da4;
        color:white;
    }
    /* checkout */

    .separadorCheckout {
        padding: 0px;
        border: 0.15px solid #dddddd;
    }

    .contenidoCkeckout, .contenidoCkeckout .row {
        padding: 0px 20px;
    }

    .btn-paypal {
        background-color: #2E9EE3;
    }
</style>